<template>
    <div class="spWithdrawal">
        <sPWithdrawal :hostroletype="hostroletype" :hostroleinnerid="hostroleinnerid"></sPWithdrawal>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import SPWithdrawal from 'views/orderMgt/finance/Withdrawal.vue'
export default {
    name: 'Withdrawal',
    data() {
        return {
            hostroletype: 4,
            hostroleinnerid: ''
        }
    },
    mounted() {
        this.hostroleinnerid = this.user.providerinnerid
    },
    methods: {
        ...mapActions([])
    },
    watch: {},
    filters: {},
    computed: {
        ...mapGetters(['user'])
    },
    components: {
        SPWithdrawal
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
</style>
